import { objectWithoutKeys } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { LoadEcsTreatmentsFulfilledAction } from '../../domains/ecs/actions.types';
import {
  ExperimentAddOverrideAction,
  ExperimentRemoveAllOverridesAction,
  ExperimentRemoveOverrideAction,
} from '../../domains/experiments/actions.types';

import { EcsExperiments, defaultExperimentTreatments } from './types';

export type EcsExperimentAction =
  | LoadEcsTreatmentsFulfilledAction
  | ExperimentAddOverrideAction
  | ExperimentRemoveAllOverridesAction
  | ExperimentRemoveOverrideAction;

const initialState: EcsExperiments = {
  treatments: defaultExperimentTreatments,
  treatmentsFromService: {},
  treatmentOverrides: {},
};

const reducer: Reducer<EcsExperiments, EcsExperimentAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEATURE_FLIGHTING.LOAD_ECS_TREATMENTS_FULFILLED':
      return {
        ...state,
        treatments: {
          ...defaultExperimentTreatments,
          ...action.payload.ecsExperimentTreatments,
          ...state.treatmentOverrides,
        },
        treatmentsFromService: action.payload.ecsExperimentTreatments,
      };

    case 'FEATURE_FLIGHTING.EXPERIMENT_ADD_OVERRIDE': {
      const experiment = action.payload.experiment;
      const newValue = action.payload.value;

      return {
        ...state,
        treatments: {
          ...state.treatments,
          [experiment]: newValue,
        },
        treatmentOverrides: {
          ...state.treatmentOverrides,
          [experiment]: newValue,
        },
      };
    }

    case 'FEATURE_FLIGHTING.EXPERIMENT_REMOVE_OVERRIDE': {
      const experiment = action.payload.experiment;
      const restoredValue = state.treatmentsFromService[experiment] ?? defaultExperimentTreatments[experiment];
      const remainingOverrides = objectWithoutKeys(state.treatmentOverrides, [experiment]);

      return {
        ...state,
        treatments: {
          ...state.treatments,
          [experiment]: restoredValue,
        },
        treatmentOverrides: remainingOverrides,
      };
    }

    case 'FEATURE_FLIGHTING.EXPERIMENT_REMOVE_ALL_OVERRIDES':
      return {
        ...state,
        treatments: {
          ...defaultExperimentTreatments,
          ...state.treatmentsFromService,
        },
        treatmentOverrides: {},
      };

    default:
      return state;
  }
};

export default reducer;
